import { ContestBasic } from '@maxpreps/apiserviceclients/apiModels';
import { FetchResponse } from '@maxpreps/apiserviceclients/fetchResponse';
import { ghostApiSimpleWrapper } from '@maxpreps/network/src/simpleWrapper';

export const deleteBulkContests = async (
  teamId,
  sportSeasonId,
  contestIds,
  token
) =>
  ghostApiSimpleWrapper(
    `/contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/remove/v1`,
    {
      method: 'POST',
      body: JSON.stringify(contestIds),
      headers: {
        Pragma: 'no-cache',
        'mp-sources-page-source': 'Desktop_CoachAdmin',
        'mp-sources-contest-source': 'CoachAdmin',
        'mp-sources-contest-subsource': 'None',
        'mp-sources-contest-type': 'ContestDeletion',
        'mp-sources-contest-subtype': 'None',
        'mp-sources-user-source': 'None'
      },
      token
    }
  ) as Promise<FetchResponse<ContestBasic[]>>;

export const deleteSingleContest = async (
  teamId,
  sportSeasonId,
  contestId,
  token
) => deleteBulkContests(teamId, sportSeasonId, [contestId], token);

export const restoreBulkContests = async (
  teamId,
  sportSeasonId,
  contestIds,
  token
) =>
  ghostApiSimpleWrapper(
    `/contests/teams/${teamId}/sportseasons/${sportSeasonId}/contests/restore/v1`,
    {
      method: 'POST',
      body: JSON.stringify(contestIds),
      headers: {
        'mp-sources-contest-source': 'CoachAdmin',
        'mp-sources-contest-subsource': 'None',
        'mp-sources-contest-type': 'ContestRestored',
        'mp-sources-contest-subtype': 'None',
        'mp-sources-page-source': 'Desktop_CoachAdmin'
      },
      token
    }
  ) as Promise<FetchResponse<ContestBasic[]>>;

export const restoreSingleContest = async (
  teamId,
  sportSeasonId,
  contestId,
  token
) => restoreBulkContests(teamId, sportSeasonId, [contestId], token);

export const copySchedule = async (
  teamId,
  sportSeasonId,
  fromSportSeasonId,
  defaultTime,
  token
) =>
  ghostApiSimpleWrapper(
    `/contests/teams/${teamId}/sportseasons/${sportSeasonId}/copy-schedule/v1`,
    {
      method: 'POST',
      body: JSON.stringify({ fromSportSeasonId, defaultTime }),
      headers: {
        'mp-sources-page-source': 'Desktop_CoachAdmin',
        'mp-sources-contest-source': 'CoachAdmin',
        'mp-sources-contest-subsource': 'None',
        'mp-sources-contest-type': 'ContestAddition',
        'mp-sources-contest-subtype': 'None',
        'mp-sources-user-source': 'None'
      },
      token
    }
  );
